// src/services/cloudinaryService.ts

// Validate environment variables
if (!process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || !process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET) {
    throw new Error('Cloudinary environment variables are not set');
  }
  
  const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`;
  const CLOUDINARY_DELETE_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/destroy`;
  
  // Upload an image to Cloudinary
  export const uploadToCloudinary = async (file: File): Promise<{ url: string; public_id: string; asset_id: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET as string);
  
    try {
      const response = await fetch(CLOUDINARY_UPLOAD_URL, {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error('Failed to upload image');
      }
  
      const data = await response.json();
      return {
        url: data.secure_url,
        public_id: data.public_id,
        asset_id: data.asset_id,
      };
    } catch (error) {
      console.error('Error uploading to Cloudinary:', error);
      throw error;
    }
  };
  
  // Delete an image from Cloudinary
  export const deleteFromCloudinary = async (public_id: string): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('public_id', public_id);
  
      const response = await fetch(CLOUDINARY_DELETE_URL, {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error(`Failed to delete image with public_id ${public_id}`);
      }
  
      console.log('Image deleted successfully:', public_id);
    } catch (error) {
      console.error(`Error deleting image with public_id ${public_id}:`, error);
      throw error;
    }
  };